<kui-card class="routing-card flex-1 d-flex">
    <kui-card-body class="flex-1 d-flex flex-column">
        @for (item of markers; track item; let i = $index) {
            <div class="position-relative">
                <key-map-toolbar-routing-input
                    [placeholder]="getInputPlaceholderText(i, markers)"
                    [text]="item.input"
                    [id]="item.marker.id"
                    (onSelected)="markerUpdated(i, $event)"
                ></key-map-toolbar-routing-input>
                @if (isNotFirstInput(i) && item.marker.lat && item.marker.lon) {
                    <kui-icon
                        kui-action
                        name="sort-alt"
                        [title]="'LEAFLET.ROUTING.INPUT.SWOP_POINTS' | translate"
                        (click)="swopPointsAtIndexes(i)"
                        class="routing-card__input-swop-icon"
                    ></kui-icon>
                }
            </div>
        }

        @if (loading || errorMessage || !!routes?.length) {
            <div class="routing-card__info flex-1 d-flex flex-column">
                <h5>{{ "LEAFLET.ROUTING.TITLE" | translate }}</h5>
                @if (loading) {
                    <kui-loader></kui-loader>
                } @else {
                    @if (errorMessage) {
                        <kui-alert-panel [message]="errorMessage"></kui-alert-panel>
                    }
                    @if (!errorMessage) {
                        <div class="routing-card__info-list flex-1 overflow-auto">
                            @for (route of routes; track route) {
                                <key-listing [hover]="true" [active]="route.active" (click)="setActiveRoute(route.id)">
                                    <key-listing-avatar>
                                        <kui-icon name="directions" [size]="'md'"></kui-icon>
                                    </key-listing-avatar>
                                    <key-listing-stat [class.text-success]="route.strategy === 'fastest'">{{
                                        "LEAFLET.ROUTING.STRATEGY." + (route.strategy | uppercase) | translate
                                    }}</key-listing-stat>
                                    <key-listing-title class="mb-1">{{ route.description }}</key-listing-title>
                                    <key-listing-description>{{ route.distance | units: "distance" }} | {{ route.time | formatSeconds }}</key-listing-description>
                                </key-listing>
                            }
                        </div>
                    }
                }
                <div class="actions">
                    @if (activeRoute) {
                        <button kui-button color="primary" class="mr-1" (click)="saveSelectedRoute(activeRoute)">
                            {{ "LEAFLET.ROUTING.SAVE" | translate }}
                        </button>
                    }
                    <button kui-button color="secondary" (click)="onClose.emit()">
                        {{ "DIALOG.CLOSE" | translate }}
                    </button>
                </div>
            </div>
        }
    </kui-card-body>
</kui-card>
